const API_URL =
  'https://digital.trxtraining.com/api/shopify-utils/ios-store/reviews';

function createStars(maxStars, rating) {
  let starsHTML = '';

  for (let i = 1; i <= maxStars; i++) {
    var polygonPoints =
      '12,2 15.09,8.36 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.36';

    // Calculate the decimal part of the rating value
    var fillStyle = '#ffd700'; // Full star

    // Create SVG string
    var currentSvgString = `
    <svg class="star" viewBox="0 0 24 24">
      <polygon points="${polygonPoints}" style="fill: ${fillStyle}"/>
    </svg>
  `;

    // Concatenate to the result
    starsHTML += currentSvgString;
  }

  return starsHTML;
}

function renderReviewCard(review) {
  let card = '';
  const dateObject = new Date(review.createdDate);
  var day = ('0' + dateObject.getDate()).slice(-2);
  var month = ('0' + (dateObject.getMonth() + 1)).slice(-2);
  var year = dateObject.getFullYear().toString().slice(-2);

  var formattedDate = `${day}/${month}/${year}`;

  const percentage = Math.round((review.rating / 5) * 100);

  card = `
      <div class="review_card_container">
        <div class="review_card_container__name">${
          review.reviewerNickname
        }</div>
        <div class="review_card_container__title">
          <div class="review_card_container__title__rating_title">
            <span class="stars_container">
              ${createStars(5, review.rating)}
              <div class="stars_overlay" style="width:${
                100 - percentage
              }%;"></div>
            </span>
            <div class="review_title">${review.title}</div>
          </div>
          <p class="review_body">${review.body}</p>
        </div>
        <div class="review_card_container__date">${formattedDate}</div>
      </div>
    </div>
  `;

  return card;
}

function createRatingStarElement({ userRatingCount, averageUserRating }) {
  var maxStars = 5;

  var starRatingDiv = document.getElementById('subs-rating');

  const accessibility = document.createElement('p');

  accessibility.className = 'rating_accessibility';
  accessibility.ariaLabel = `Rating is ${averageUserRating} out of 5`;

  for (var i = 1; i <= 5; i++) {
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('class', 'star');
    svg.setAttribute('viewBox', '0 0 24 24');

    var polygon = document.createElementNS(
      'http://www.w3.org/2000/svg',
      'polygon'
    );
    polygon.setAttribute(
      'points',
      '12,2 15.09,8.36 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.36'
    );

    // Calculate the decimal part of the rating value
    polygon.style.fill = '#ffd700'; // Full star

    svg.appendChild(polygon);
    // ratingContainer.appendChild(svg);
    accessibility.appendChild(svg);
  }

  const totalReviews = document.createElement('span');
  totalReviews.innerHTML = `${userRatingCount} reviews`;
  totalReviews.className = 'reviews_label';

  const percentage = Math.round((averageUserRating / 5) * 100);

  var overlayTemplate = `<div class="stars_overlay" style="width:${
    100 - percentage
  }%;" />`;

  accessibility.innerHTML += overlayTemplate;
  starRatingDiv.appendChild(accessibility);
  starRatingDiv.appendChild(totalReviews);
}

function createReviewsSection(reviews) {
  const reviewsContainer = document.getElementById('reviews_list');

  reviews.forEach((review, index) => {
    var reviewCard = document.createElement('div');
    reviewCard.className = 'review-card';
    reviewCard.innerHTML = renderReviewCard(review.attributes);
    reviewsContainer.appendChild(reviewCard);

    if (index < reviews.length) {
      const separator = document.createElement('div');
      separator.className = 'separator';
      reviewsContainer.appendChild(separator);
    }
  });
}

function beforeReviewsFetch() {
  const errorElement = document.getElementById('error-review');
  errorElement.hidden = true;
  const loaderEl = document.getElementById('spinner-review');
  loaderEl.hidden = false;
  const loadMoreButton = document.getElementById('load-more-button');
  loadMoreButton.hidden = true;
}

function afterReviewsFetch() {
  const loaderEl = document.getElementById('spinner-review');
  loaderEl.hidden = true;
  const loadMoreButton = document.getElementById('load-more-button');
  loadMoreButton.hidden = false;
}

async function fetchReviews() {
  beforeReviewsFetch();
  const pageHtml = document.getElementById('reviews_counter');
  const page = pageHtml?.innerHTML || '1';

  const url =
    page === '1'
      ? `${API_URL}?page=${page}&getAverage=true`
      : `${API_URL}?page=${page}`;

  await $.ajax({
    url: url,
    type: 'GET',
    dataType: 'json',

    success: function (response) {
      if (page === '1') createRatingStarElement(response.ratingInfo);
      createReviewsSection(response.reviews);
      afterReviewsFetch();
      pageHtml.innerHTML = parseInt(page) + 1;
    },
    error: function () {
      afterReviewsFetch();
      const errorElement = document.getElementById('error-review');
      errorElement.hidden = false;
    },
  });
}

fetchReviews();
